import { all } from 'redux-saga/effects';
import { dataTableWatcher } from '@/features/dataTable/sagas/dataTableSagas';
import { partyPaymentInformationWatcher } from '@/features/drawer/components/PartyPaymentInformation/sagas/partyPaymentInformation.saga';
import { editModeWatcher } from '@/features/editMode/sagas/editModeWatcher';
import { entityDetailsWatcher } from '@/features/entityDetails/sagas/entityDetailsWatcher';
import { geographyWatcher } from '@/features/geography/sagas/geographySagas';
import { globalSearchWatcher } from '@/features/globalSearch/sagas/globalSearch';
import { googleAddressValidationApiWatcher } from '@/features/googleApi/addressValidationApi/sagas/googleAddressValidationApiSagas';
import { googlePlacesApiWatcher } from '@/features/googleApi/placesApi/sagas/googlePlacesApiSagas';
import { partiesWatcher } from '@/features/parties/sagas/partiesWatcher';
import { systemWatcher } from '@/features/system/sagas/systemSagas';
import { addressWatcher } from '@/domains/addresses/sagas/addressesSagas';
import { createTransactionFromAdjustmentWatcher } from '@/domains/adjustments/sagas/createTransactionFromAdjustment.saga';
import { deleteAdjustmentWatcher } from '@/domains/adjustments/sagas/deleteAdjustment.saga';
import { adminUsersWatcher } from '@/domains/adminUsers/sagas/adminUsersWatcher';
import { assignmentQueuesWatcher } from '@/domains/assignmentQueues/sagas/assignmentQueuesWatcher';
import { authWatcher } from '@/domains/auth/sagas/authSagas';
import { beneficiaryWatcher } from '@/domains/beneficiaries/sagas/beneficiarySagas';
import { createBeneficiaryWatcher } from '@/domains/beneficiaries/sagas/createBeneficiarySagas';
import { benefitCalculationDetailsWatcher } from '@/domains/benefits/sagas/benefitCalculationWatcher';
import { benefitsWatcher } from '@/domains/benefits/sagas/benefitsWatcher';
import { allClaimSetsWatcher } from '@/domains/claimSets/sagas/allClaimSetsWatcher';
import { claimSetWatcher } from '@/domains/claimSets/sagas/claimSetWatcher';
import { claimSetCreationWatcher } from '@/domains/claimSets/sagas/createClaimSetWatcher';
import { claimantsWatcher } from '@/domains/claimants/sagas/claimantsSagas';
import { createClaimantWatcher } from '@/domains/claimants/sagas/createClaimantSagas';
import { claimSetClaimListWatcher } from '@/domains/claims/features/ClaimSetClaimList/sagas/claimSetClaimListWatcher';
import { allClaimsWatcher } from '@/domains/claims/sagas/allClaimsWatcher';
import { claimsWatcher } from '@/domains/claims/sagas/claimsWatcher';
import { createClaimWatcher } from '@/domains/claims/sagas/createClaimWatcher';
import { contactWatcher } from '@/domains/contacts/sagas/contactSagas';
import { createContactWatcher } from '@/domains/contacts/sagas/createContactSagas';
import { coveragesWatcher } from '@/domains/coverages/sagas/coveragesSagas';
import { decisionTablesWatcher } from '@/domains/decisionTables/sagas/decisionTablesWatcher';
import { documentInstancesWatcher } from '@/domains/documents/sagas/documentInstancesWatcher';
import { systemDocumentWatcher } from '@/domains/documents/sagas/documentsWatcher';
import { generateDocumentWatcher } from '@/domains/documents/sagas/generateDocumentWatcher';
import { helperTagsWatcher } from '@/domains/helperTags/sagas/helperTagsWatcher';
import { createInsuredWatcher } from '@/domains/insureds/sagas/createInsuredSagas';
import { insuredWatcher } from '@/domains/insureds/sagas/insuredSagas';
import { milestonesWatcher } from '@/domains/milestones/sagas/milestonesWatcher';
import { requestedItemsWatcher } from '@/domains/milestones/sagas/requestedItemsWatcher';
import { createNoteDocumentWatcher } from '@/domains/notes/sagas/createNoteDocumentWatcher';
import { createNoteWatcher } from '@/domains/notes/sagas/createNoteWatcher';
import { notesWatcher } from '@/domains/notes/sagas/notesWatcher';
import { partyDetailsWatcher } from '@/domains/partyDetails/sagas/partyDetails.saga';
import { partyDetailsTabsWatcher } from '@/domains/partyDetails/sagas/partyDetailsTabs.saga';
import { paymentsWatcher } from '@/domains/payments/features/PaymentsSection/sagas/payments.watcher';
import { addPaymentWatcher } from '@/domains/payments/features/paymentModals/modals/AddPayment/sagas/addPayment.saga';
import { addPaymentMethodWatcher } from '@/domains/payments/features/paymentModals/modals/AddPaymentMethod/sagas/addPaymentMethod.saga';
import { addPaymentSplitWatcher } from '@/domains/payments/features/paymentModals/modals/AddPaymentSplit/sagas/addPaymentSplit.saga';
import { editPaymentMethodWatcher } from '@/domains/payments/features/paymentModals/modals/EditPaymentMethod/sagas/editPaymentMethod.saga';
import { addAdjustmentWatcher } from '@/domains/payments/features/paymentModals/modals/adjustments/sagas/addAdjustment.saga';
import { addPayeeWatcher } from '@/domains/payments/features/paymentModals/modals/payee/sagas/addPayee.saga';
import { addPolicyWatcher } from '@/domains/policies/sagas/addPolicyWatcher';
import { potentialPoliciesWatcher } from '@/domains/policies/sagas/potentialPoliciesSagas';
import { producerWatcher } from '@/domains/producer/saga/producer.saga';
import { producersWatcher } from '@/domains/producers/sagas/producersWatcher';
import { profileDetailsWatcher } from '@/domains/profileDetails/sagas/profileDetailsSagas';
import { recentActivityListWatcher } from '@/domains/recentActivity/sagas/recentActivitySagas';
import { taskListWatcher } from '@/domains/tasks/features/myTaskList/saga/taskListWatcher';
import { createTaskWatcher } from '@/domains/tasks/sagas/createTaskWatcher';
import { tasksWatcher } from '@/domains/tasks/sagas/tasksWatcher';
import { transactionDetailsWatcher } from '@/domains/transactions/sagas/transactionWatcher';
import { userWatcher } from '@/domains/user/sagas/userSagas';

export default function* rootSaga() {
  yield all([
    systemWatcher(),
    authWatcher(),
    userWatcher(),
    adminUsersWatcher(),
    claimSetWatcher(),
    systemDocumentWatcher(),
    editModeWatcher(),
    beneficiaryWatcher(),
    benefitCalculationDetailsWatcher(),
    benefitsWatcher(),
    addPolicyWatcher(),
    claimSetClaimListWatcher(),
    createContactWatcher(),
    contactWatcher(),
    entityDetailsWatcher(),
    insuredWatcher(),
    geographyWatcher(),
    claimSetCreationWatcher(),
    googlePlacesApiWatcher(),
    googleAddressValidationApiWatcher(),
    addressWatcher(),
    createBeneficiaryWatcher(),
    tasksWatcher(),
    claimsWatcher(),
    createClaimWatcher(),
    profileDetailsWatcher(),
    claimantsWatcher(),
    createClaimantWatcher(),
    coveragesWatcher(),
    allClaimSetsWatcher(),
    allClaimsWatcher(),
    createTaskWatcher(),
    milestonesWatcher(),
    createInsuredWatcher(),
    requestedItemsWatcher(),
    potentialPoliciesWatcher(),
    recentActivityListWatcher(),
    taskListWatcher(),
    globalSearchWatcher(),
    partiesWatcher(),
    addPaymentWatcher(),
    paymentsWatcher(),
    generateDocumentWatcher(),
    transactionDetailsWatcher(),
    addAdjustmentWatcher(),
    deleteAdjustmentWatcher(),
    addPayeeWatcher(),
    notesWatcher(),
    createNoteWatcher(),
    createNoteDocumentWatcher(),
    addPaymentMethodWatcher(),
    createTransactionFromAdjustmentWatcher(),
    editPaymentMethodWatcher(),
    addPaymentSplitWatcher(),
    assignmentQueuesWatcher(),
    helperTagsWatcher(),
    partyDetailsWatcher(),
    partyDetailsTabsWatcher(),
    partyPaymentInformationWatcher(),
    producerWatcher(),
    producersWatcher(),
    dataTableWatcher(),
    documentInstancesWatcher(),
    decisionTablesWatcher(),
  ]);
}
